import { z } from 'zod';

/*
  TODO убрать поддержку старой версии
  Раньше отзывы можно было оставить проживанию. Теперь отзывы появились и у экскурсий.
  Для поддержки разных видов сущностей, появились поля type и entityId и ушло propertyId.
  Однако, ссылки со старым синтаксисом только для проживания остаются живыми некоторое время,
  и их пока нужно поддерживать.

  Когда после деплоя отзывов TTL всех старых ссылок истечет, можно убрать refine, propertyId и optional
*/
export const bookingIdSearchSchema = z
  .object({
    bookingId: z.string().uuid(),
    entityId: z.string().uuid().optional(),
    type: z
      .enum(['excursion', 'accommodation'])
      .catch('accommodation')
      .default('accommodation'),
    propertyId: z.string().uuid().optional(),
  })
  .refine((data) => data.entityId || data.propertyId);
